import React from "react";
import DataTable from 'react-data-table-component';

function CountByYearTable(props) {

    if(props.data === null) {
        return (
            <div className="card my-3 mx-3">
                <div className="card-body d-flex align-items-center justify-content-center">
                    Failed to create visualization
                </div>
            </div>
        )
    }
    else {

        const columnNames = new Set();
        props.data.forEach(record => {
            Object.keys(record).forEach(key => {
                if (key !== 'TRAIT') {
                    columnNames.add(key);
                }
            })
        });
        const columnNamesArray = Array.from(columnNames);
        columnNamesArray.sort();
        const columns = [];
        columns.push(
            {
                name: 'TRAIT',
                width: "120px",
                selector: row => row['TRAIT']
            }
        );
        columnNamesArray.forEach(value => {
            columns.push(
                {
                    name: value,
                    width: "120px",
                    selector: row => row[value]
                }
            );
        });


        return (
            <div className="card my-3 mx-3">
                <div className="card-body">
                    <h6 className="card-title">Number of Observations By Year</h6>
                    <DataTable
                        fixedHeader={true}
                        fixedHeaderScrollHeight="400px"
                        columns={columns}
                        data={props.data}
                    />
                </div>
            </div>
        )
    }
}

export default CountByYearTable;